import { provideAppInitializer, ApplicationConfig, inject } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { PosthogService } from './services/posthog.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { AmplifyAuthSubscriptionService } from './services/amplify-auth-subscription.service';
import { routes } from './app.routes';

import {provideTranslateService} from "@ngx-translate/core";
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import {provideHttpClient} from "@angular/common/http";
import { TranslateService } from '@ngx-translate/core';
import { provideEchartsCore } from 'ngx-echarts';

const SUPPORTED_LANGS = ['fr', 'nl'];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withViewTransitions({
        skipInitialTransition: true,
        onViewTransitionCreated: () => {
          // Scroll to top on each navigation
          window.scrollTo(0, 0);
        }
      })
    ),
    provideAppInitializer(() => {
      const posthog = inject(PosthogService);
      return posthog.initializeForUser();
    }),
    provideAppInitializer(() => {
      inject(GoogleAnalyticsService).init();
    }),
    provideAppInitializer(()=>{
      const amplifyAuthSubscriptionService = inject(AmplifyAuthSubscriptionService);
      return amplifyAuthSubscriptionService.initializeSubscription();
    }),
    provideHttpClient(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      defaultLanguage: 'fr'
    }),
    provideEchartsCore({ echarts: () => import('echarts') }),
    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      translate.addLangs(SUPPORTED_LANGS);

      const savedLang = localStorage.getItem('language');
      const browserLang = translate.getBrowserLang();
      const langToUse = savedLang && SUPPORTED_LANGS.includes(savedLang)
        ? savedLang
        : (browserLang && SUPPORTED_LANGS.includes(browserLang) ? browserLang : 'fr');

      translate.use(langToUse);
    })
  ]
};
